import { render, staticRenderFns } from "./RegistrationForm.vue?vue&type=template&id=b2b5893a&scoped=true&"
import script from "./RegistrationForm.vue?vue&type=script&lang=js&"
export * from "./RegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RegistrationForm.vue?vue&type=style&index=1&id=b2b5893a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b5893a",
  null
  
)

export default component.exports